/* resetMfa/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const DataCodec = t.intersection([
  t.type({
    terminal_id: tId
  }),
  t.partial({
   
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;

export const ResetSTANCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "ResetSTANCodec"
);

export type ResetSTAN = t.TypeOf<typeof ResetSTANCodec>;

export enum ResetSTANActionTypes {
  FETCH = "@@TerminalSTAN/FETCH",
  FETCH_PERMISSION = "@@TerminalSTAN/FETCH_PERMISSION",
  FETCH_SUCCESS = "@@TerminalSTAN/FETCH_SUCCESS",
  FETCH_ERROR = "@@TerminalSTAN/FETCH_ERROR",
  SAVE_REQUEST = "@@TerminalSTAN/SAVE_REQUEST",
  SAVE_SUCCESS = "@@TerminalSTAN/SAVE_SUCCESS",
  SAVE_ERROR = "@@TerminalSTAN/SAVE_ERROR",
  DELETE_REQUEST = "@@TerminalSTAN/DELETE_REQUEST",
  DELETE_SUCCESS = "@@TerminalSTAN/DELETE_SUCCESS",
  DELETE_ERROR = "@@TerminalSTAN/DELETE_ERROR",
}

export interface ResetSTANState {
  readonly loading: boolean;
  readonly data: ResetSTAN | undefined;
  readonly errors?: string;
}
